import { Calendar } from "lucide-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DateFilter({ value, onDateChange }) {
    return (
        <div className="w-full relative">
            <DatePicker
                selected={value ? new Date(value) : null}
                // onChange={(date) => {
                //     console.log("date ::>",date);
                //     onDateChange(date ? date.toLocaleString() : null);
                // }}
                onChange={(date) => {
                    if (!date) {
                        onDateChange("");
                        return;
                    }

                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");

                    const formattedDate = `${year}-${month}-${day}`;
                    onDateChange(formattedDate);
                }}
                isClearable
                dateFormat="yyyy-MM-dd"
                placeholderText="Select date"
                // className="w-full text-gray-900 px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none"
                className="w-full text-gray-900 px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#ff696866] outline-none"
            />

            <Calendar
                size={18}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
            />
        </div>
    );
}

export default DateFilter;
